module.exports = __webpack_public_path__ + "img/woods_03_minified.709500b9.jpg";